import { render, staticRenderFns } from "./SFTextarea.vue?vue&type=template&id=2440a72b&lang=pug&"
import script from "./SFTextarea.vue?vue&type=script&lang=ts&"
export * from "./SFTextarea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports